import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { Providers } from 'generated/graphql-types';
import { getProviders, providerSearch } from 'src/app/common-components/helpers/provider-helper';
import { ProviderCallCostFormValue } from '../models/add-provider-call-costs-data';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-add-provider-call-costs-view',
    templateUrl: './add-provider-call-costs-view.component.html',
    styleUrls: ['./add-provider-call-costs-view.component.scss'],
    standalone: false
})
export class AddProviderCallCostViewComponent implements OnInit {
   @Input() callState: CallState;

   @Output() formSubmitted = new EventEmitter<ProviderCallCostFormValue>();

   @Output() formCanceled = new EventEmitter<void>();

   @Input() form: UntypedFormGroup;

   providers = getProviders();

   isSubmitted = false;

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(): void {
      this.isSubmitted = true;
      if (this.form.valid) {
         this.formSubmitted.emit();
      }
   }
   ngOnInit(): void {
      this.form.addControl('File', new UntypedFormControl('', Validators.nullValidator));
      this.form.addControl('providerId', new UntypedFormControl('', [Validators.required]));
   }

   providerDisplayWith(option: Providers): string {
      return `${option ?? ''}`;
   }

   providerSearch(searchText: string) {
      this.providers = providerSearch(searchText);
   }

   providerReset() {
      this.providers = getProviders();
   }

   onRadioChange(event: any): void {
      const selectedValue = event.value;

      this.form.get('radioControl')?.setValue(selectedValue);
      if (selectedValue === 'Inteliquent') {
         this.form.get('providerId')?.setValue(Providers.Inteliquent);
      } else if (selectedValue === 'Lumen') {
         this.form.get('providerId')?.setValue(Providers.Lumen);
      }
   }
}
